import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ImageDialogData {
    id: string;
    imageUrl: string;
}

@Component({
    selector: 'app-image-dialog',
    templateUrl: './image-dialog.component.html',
    styleUrls: ['./image-dialog.component.scss'],
})
export class ImageDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ImageDialogData) {}
}
